/**
 * A render that throws shows this instead of a white page.
 *
 * Plans are in IndexedDB and every edit is saved within a second, so the honest
 * advice is "reload" — and a plain link to the dashboard, which reloads too,
 * since the router that crashed is not one to trust with the way out.
 */
import { Component, type ReactNode } from 'react'

import { useT } from '../lib/i18n/I18nProvider'

export class CrashBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false }

  static getDerivedStateFromError(): { crashed: boolean } {
    return { crashed: true }
  }

  render(): ReactNode {
    return this.state.crashed ? <CrashScreen /> : this.props.children
  }
}

function CrashScreen() {
  const t = useT()
  return (
    <div className="boot boot--error crash" role="alert">
      <div>
        <h1>{t.errors.crashTitle}</h1>
        <p>{t.errors.crashBody}</p>
        <div className="crash-actions">
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            {t.common.reload}
          </button>
          <a className="btn btn-outline" href="/plans">
            {t.common.myPlans}
          </a>
        </div>
      </div>
    </div>
  )
}
